import React, { Component } from 'react';
import fire from '../fire';
import RankingListItem from './RankingListItem';
import RankingListPersonalRank from './RankingListPersonalRank';
import AdBlock from '../External/AdBlock';
import './RankingList.css';
import { FormattedMessage } from 'react-intl';

class RankingList extends Component {

    constructor(props) {
        super(props);
        this.state = {ranking: [], userRank: 0, userAfter: [], userBefore: [], userSelf: []};
        this.ranking = [];
    }

    componentWillMount(){
        /* Create reference to messages in Firebase Database */
        let rankingRef = fire.database().ref('v1/betting/ranking').orderByChild('position').limitToFirst(10);
        let ranking = this.ranking;

        rankingRef.on('value', snapshot => {
            ranking = [];
            snapshot.forEach(function (rank) {
                let rankArray = {key: rank.key, value: rank.val()};
                ranking.push(rankArray);
            });
            this.setState({ranking: ranking});
        });
    }
    returnListItem(item, key) {
        return (
            <RankingListItem rank={item.value} key={item.key} rankUser={item.key} user={this.props.user} />
        );
    }

    render() {
        if (this.state.ranking.length) {
            return (
                <div className="ranking-list container-fluid">
                    { this.state.ranking.map(this.returnListItem.bind(this)) }
                    <AdBlock locale={this.props.locale}/>
                    <RankingListPersonalRank user={this.props.user} />
                </div>
            );
        } else {
            return (
                <div className="ranking-list-text">
                    <FormattedMessage id={ 'ranking.ranking_list.text' } defaultMessage={ 'Die Rangliste ist noch nicht verfügbar. Schau doch nach dem ersten Spiel am 07.09.2017 wieder vorbei.' } />

                </div>
            );
        }

    }
}

export default RankingList;



// WEBPACK FOOTER //
// ./src/Ranking/RankingList.js